/***************************************************************
6/9/2017
Alexander Self
List of urls for side nav
***************************************************************/
import { browserHistory } from 'react-router';
import React from 'react';
const $ = window.$;


const UrlList = ({ listItems, id, _class }) => {
  $(document).ready(function(){
    $('.tooltipped').tooltip({delay: 50});
  });
  return (
    <div>
      <ul id={id} className="collection">
        {
          listItems.map((item, i) => (
            <li key={`${item}${i}`} className={`collection-item avatar ${_class} nav-icon tooltipped`} onClick={() => browserHistory.push(`${item.url}`)}
              data-position="right" data-delay="50" data-tooltip={item.name}>
              <i className={`${ item._class } material-icons circle`}>{ item.icon }</i>
            </li>
          ))
        }
        <li key={`weather8`} className={`collection-item side-navigation avatar nav-icon tooltipped`} onClick={() => browserHistory.push(`/weather`)}
          data-position="right" data-delay="50" data-tooltip={'Weather'}>
          <i className={`wi wi-day-rain orange lighten-2 circle`}></i>
        </li>
      </ul>
    </div>
  )
};

export default UrlList;



// WEBPACK FOOTER //
// ./src/components/url_list.js